import { connect } from 'react-redux';
import { compose, pure } from 'utils/react';
import Websites from '../components/Websites';

export default compose(
  connect(
    ({ hyper: { sites } }) => ({ sites }),
  ),
  pure(),
)(Websites);
